module.exports = __webpack_public_path__ + "img/wm-syringe.f8ad6371.svg";